// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../../../../node_modules/css-loader/index.js?minimize!../../../../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-6cdd3785\",\"scoped\":false,\"hasInlineConfig\":true}!../../../../../../../node_modules/sass-loader/dist/cjs.js!./documents.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../../../../node_modules/vue-style-loader/lib/addStylesClient.js")("44a434b7", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-style-loader!./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6cdd3785","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js!./resources/assets/js/components/Orders/Shipments/Documents/documents.scss
// module id = M89C
// module chunks = 0